import { Button, Grid, Link, Typography } from "@material-ui/core";
import { TextField } from 'mui-rff';


const validate = values => {
    const errors = {};
    if (!values.code) {
        errors.code = 'Required';
    }
    if (!values.newPassword) {
        errors.newPassword = 'Required';
    }
    return errors;
};


export const AccountRecoveryMetadataBuilder = () => (new _AccountRecoveryMetadataBuilder());
 class _AccountRecoveryMetadataBuilder {

    constructor() {
        this.inputs = {
            onSubmitFunction: () => { },
            onCancelClick: () => {},
            errorMessage: ''
        }

        //dynamically generating setters for inputs in constructor
        Object.keys(this.inputs).forEach(input => {
            // if booleanValue, it will have the property name became has
            let functionNameValue = (typeof this.inputs[input] == "boolean") ?
                `has${input.charAt(0).toUpperCase() + input.slice(1)}` :
                `with${input.charAt(0).toUpperCase() + input.slice(1)}`;

            this[`${functionNameValue}`] = (value) => {
                this.inputs[`${input}`] = value;
                return this;
            }
        })
    }

    build() {
        return (
            AccountRecoveryMetadata(this.inputs.onSubmitFunction, this.inputs.onCancelClick, this.inputs.errorMessage)
        )
    }
}

export const AccountRecoveryMetadata = (onSubmitFunction, onCancelClick, errorMessage) => {
    return (
        {
            onSubmit: onSubmitFunction,
            validateFunction: validate,

            sections: [
                {
                    uiComponent: Grid,
                    props: {
                        id: "loginIntoYourAccount",
                        className: "login_into_your_account",
                        container: true,
                        alignItems: "center",
                        spacing: 2
                    },

                    elements: [
                        {
                            size: 12,
                            uiComponent:Typography,
                            props: {
                                text: errorMessage,
                                className: errorMessage ? 'error-message' : 'hidden-error-message',
                                children: errorMessage
                            }
                        },

                        {
                            size: 6,
                            uiComponent: Typography,
                            props: {
                                text: "Enter your code to set a new password.",
                                children: "Enter your code to set a new password.",
                                className: "headline"
                            }
                        },
                        {
                            size: 6,
                            uiComponent: Link,
                            props: {
                                className: "cancel_forgot_password",
                                children: "Cancel and login",
                                onClick: () => {
                                    onCancelClick();
                                }
                            }
                        },
                        {
                            size: 6,
                            uiComponent: TextField,
                            props: {
                                type: "text",
                                label: "Code",
                                placeholder: "",
                                InputLabelProps: { shrink: true },
                                name: "code"
                            }
                        },
                        {
                            size: 6,
                            uiComponent: TextField,
                            props: {
                                type: "password",
                                label: "New Password",
                                placeholder: "",
                                name: "newPassword"
                            }
                        },
                        {
                            size: 6,
                            uiComponent: Button,
                            props: {
                                type: "submit",
                                variant: "contained",
                                children: "Set new password",
                            }
                        }
                    ]
                }
            ]
        }

    )
}
